<template>
  <div id="laboratorys">
    <div class="row banner">
      <div class="col-md-12">
        <img :src="data.nav_pic" alt="南京app开发" title="南京app开发" />
        <div class="texts">
          <div>{{ data.nav_title }}</div>
          <div>{{ data.nav_desc }}</div>
        </div>
      </div>
    </div>
    <div class="boding">
      <div class="center">
        <div class="middle">
          <p class="title">{{ articleData.title }}</p>
          <div class="info">
            <span
              ><a href="https://www.mokyun.com">{{
                articleData.author
              }}</a></span
            >
            <span
              ><img
                title="南京小程序开发"
                alt="南京小程序开发"
                src="../assets/Laboratory/time.png"
              />{{ articleData.time }}</span
            >
            <span
              ><img
                title="南京小程序开发"
                alt="南京小程序开发"
                src="../assets/Laboratory/eye.png"
              />{{ articleData.click }}人浏览</span
            >
            <span
              ><img
                title="南京小程序开发"
                alt="南京小程序开发"
                src="../assets/Laboratory/info.png"
              />评论{{ commentNum }}</span
            >
          </div>
          <div class="labels" v-show="label">
            <span v-for="(item, index) in articleData.label">{{ item }}</span>
          </div>
          <div class="article">
            <div v-html="articleData.content"></div>
          </div>

          <div class="pageTurning">
            <div class="left">
              <div
                :class="articleData.preTitle == '没有了' ? 'no-img' : 'yes-img'"
              >
                <img
                  :src="articleData.prePic + '-mokyun_site_lab_detail_cover'"
                  class="pic"
                  title="南京小程序开发"
                  alt="南京小程序开发"
                  v-show="leftImg"
                />
              </div>

              <div
                class="page-change"
                v-show="articleData.preTitle != '没有了'"
              >
                <div
                  class="jump-btn"
                  @click="changeText(articleData.preId)"
                  :style="leftImg ? 'cursor: pointer;' : 'opacity: 0;'"
                >
                  <img
                    title="南京小程序开发"
                    alt="南京小程序开发"
                    src="../assets/Laboratory/left.png"
                  />上一篇
                </div>
                <div class="jump-txt">
                  <p>{{ articleData.preTitle }}</p>
                  <p>{{ articleData.preDesc }}</p>
                </div>
              </div>
              <div
                v-show="articleData.preTitle == '没有了'"
                class="no-data-page"
              >
                <img
                  src="../assets/noData.png"
                  title="南京小程序开发"
                  alt="南京小程序开发"
                />
                <div
                  style="text-align: center;color: #a1a4a5;margin-top: 15px;"
                >
                  没有了
                </div>
              </div>
            </div>
            <div class="right">
              <div
                :class="
                  articleData.nextTitle == '已是最后一篇' ? 'no-img' : 'yes-img'
                "
              >
                <!-- <img :src="articleData.nextPic" class="pic img-responsive" v-show="rightImg"/> -->
                <img
                  :src="articleData.nextPic + '-mokyun_site_lab_detail_cover'"
                  class="pic"
                  v-show="rightImg"
                  alt="南京小程序开发"
                />
              </div>

              <div
                class="page-change"
                v-show="articleData.nextTitle != '已是最后一篇'"
              >
                <div class="jump-txt">
                  <p>{{ articleData.nextTitle }}</p>
                  <p>{{ articleData.nextDesc }}</p>
                </div>
                <div
                  class="jump-btn"
                  @click="changeText(articleData.nextId)"
                  :style="rightImg ? 'cursor: pointer;' : 'opacity: 0;'"
                  v-show="rightImg"
                >
                  下一篇<img
                    src="../assets/Laboratory/right.png"
                    title="南京小程序开发"
                    alt="南京小程序开发"
                  />
                </div>
              </div>
              <div
                v-show="articleData.nextTitle == '已是最后一篇'"
                class="no-data-page"
              >
                <img
                  src="../assets/noData.png"
                  title="南京小程序开发"
                  alt="南京小程序开发"
                />
                <div
                  style="text-align: center;color: #a1a4a5;margin-top: 15px;"
                >
                  已是最后一篇
                </div>
              </div>
            </div>
          </div>

          <div class="comment">
            <div class="publish">
              <p v-show="judge">发表评论</p>
              <span
                v-show="!judge"
                style="font-size: 20px;line-height:40px;color: #353535;"
                >发表评论</span
              >
              <span :style="judge ? 'margin-left: 0;' : ''">{{
                commentContent
              }}</span>
            </div>
            <hr />
            <div class="comment-module" v-for="(item, index) in comments">
              <div class="comment-text">
                <div>
                  <!-- 777777777777 -->
                  <!-- <img :src="item.headimgurl" class="img-responsive"/> -->
                  <img
                    :src="item.headimgurl"
                    title="南京小程序开发"
                    alt="南京小程序开发"
                  />
                </div>
                <div>
                  <div>{{ item.name }}网友</div>
                  <div>{{ item.content }}</div>
                </div>
              </div>
              <div class="reply">
                <div>
                  <img
                    src="../assets/Laboratory/reply.png"
                    @click="reply(item.id)"
                    title="南京小程序开发"
                    alt="南京小程序开发"
                  /><span @click="reply(item.id)">回复</span>
                </div>
              </div>

              <div :class="item.shows ? 'comment-area' : 'hide-area'">
                <textarea
                  name=""
                  rows=""
                  cols=""
                  placeholder="回复"
                  v-model="replyText"
                ></textarea>
                <div>
                  <el-button @click="cancel">取消</el-button>
                  <el-button type="primary" @click="sureReply(item.id)"
                    >回复</el-button
                  >
                </div>
              </div>

              <div class="reply-text" v-for="(list, index) in item.reply">
                <div>
                  <span>{{ list.name }}网友回复 :</span>
                  <span>{{ list.content }}</span>
                </div>
              </div>
            </div>
            <!--<div class="seeMore" @click="seeMore" v-show="count">查看更多</div>-->
          </div>
          <div class="textarea" id="textarea">
            <textarea
              name=""
              rows=""
              cols=""
              placeholder="写下你的评论..."
              v-model="review"
            ></textarea>
            <button @click="submit">评 论</button>
          </div>
        </div>
      </div>
      <div class="recommend visible-md-block visible-lg-block">
        <div class="nominate">
          <div class="show-title">
            <span></span>
            <span>每日推荐</span>
          </div>
          <ul>
            <li
              v-for="(item, index) in recommendArticle"
              @click="changeText(item.id)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="hot">
          <div class="show-title">
            <span></span>
            <span>热门文章</span>
          </div>
          <div class="show-hot-text">
            <div class="show-image" v-for="(m, index) in hotImage">
              <img
                :src="m.pic + '-mokyun_site_lab_cover_s'"
                class="bgImg"
                @click="changeText(m.id)"
                alt="南京小程序开发"
                title="南京小程序开发"
              />
              <img
                :src="m.imgUrl"
                title="南京小程序开发"
                alt="南京小程序开发"
                class="topImg"
              />
            </div>
            <div
              v-for="(list, index) in hotArticle"
              class="show-other"
              @click="changeText(list.id)"
            >
              <div class="ranking">
                <img
                  :src="list.pic + '-mokyun_site_lab_cover_m'"
                  alt="南京小程序开发"
                  title="南京小程序开发"
                />
                <div>{{ index + 3 }}</div>
              </div>
              <div>
                <p>{{ list.title }}</p>
                <p>{{ list.t }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="goTop visible-md-block visible-lg-block"
      :style="showHide ? 'opacity: 1;' : 'display: none;opacity: 0;'"
      @click="goTop"
    >
      <div class="glyphicon glyphicon-menu-up" aria-hidden="true"></div>
      <div>TOP</div>
    </div>
  </div>
</template>

<script>
import fir from '../assets/firNoun.png';
import sec from '../assets/secNoun.png';
import axios from 'axios';
import '../assets/js/gt.js';
import '../assets/css/style.css';

import getData from '../api/getInfo';
export default {
  data() {
    return {
      articleData: {},
      comments: [],
      replyText: '',
      review: '',
      leftImg: true,
      rightImg: true,
      count: true,
      commentNum: 0,
      hotArticle: [],
      hotImage: [],
      recommendArticle: [],
      showHide: false,
      commentContent: '你是第一个来评论的,快来试试',
      judge: true,
      label: false,
      data: {},
    };
  },
  created() {
    this.getArticle(22);
    this.getComment(this.count);
    this.getHotArticle();
    this.getHeadPortrait();
    this.separate();
  },
  mounted() {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?75d1af96b450c5590fffaae8357a65e0';
      var s = document.getElementsByTagName('script')[0];
      // s.parentNode.insertBefore(hm, s)

      // var bp = document.createElement('script');
      var curProtocol = window.location.protocol.split(':')[0];
      if (curProtocol === 'https')
        hm.src = 'https://zz.bdstatic.com/linksubmit/push.js';
      else hm.src = 'https://push.zhanzhang.baidu.com/push.js';
      // var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    $(window).on('scroll', () => {
      if (document.documentElement.scrollTop >= 1800) this.showHide = true;
      else this.showHide = false;
    });
  },
  updated() {
    $('.article-img').css({ width: '100%' });
    $('.article p').css({ 'font-size': '15px', 'line-height': '25px' });
  },
  methods: {
    // 获取顶部图文信息
    separate() {
      // getData
      //   .separateImg()
      //   .then((res) => {
      let list = [
        {
          id: '1',
          nav_title: '解决方案',
          nav_pic: '1541475369769',
          nav_desc:
            '关注生活所关注的，了解商业所了解的，我们所做的一切，只是为了让科技改变生活。',
          sort: '6',
          appid: '23',
        },
        {
          id: '2',
          nav_title: '案例展示',
          nav_pic: '1541475386238',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '5',
          appid: '23',
        },
        {
          id: '6',
          nav_title: '功能',
          nav_pic: '1541488820596',
          nav_desc: '功能模块',
          sort: '4',
          appid: '23',
        },
        {
          id: '5',
          nav_title: '实验室',
          nav_pic: '1541475376231',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '3',
          appid: '23',
        },
        {
          id: '3',
          nav_title: '联系我们',
          nav_pic: '1541475595720',
          nav_desc:
            '去繁就简，留给你最好的体验，始终坚持契约精神，给我们一个机会，我们只会让你喜出望外。',
          sort: '2',
          appid: '23',
        },
        {
          id: '4',
          nav_title: '加入我们',
          nav_pic: '154147535974',
          nav_desc:
            '我们不仅仅是想做好研发，我们更想为这个蓬勃的互联网行业持续注入，开源精神，我们一直都在。',
          sort: '1',
          appid: '23',
        },
      ];
      list.forEach((v) => {
        if (v.nav_title == '实验室') {
          this.data = v;
          this.data.nav_pic = `${getData.url}${v.nav_pic}`;
        }
      });
      //   // console.log(this.data)
      // })
      // .catch((e) => {});
    },

    // 获取文章
    getArticle(id) {
      if (id == 0) {
        return;
      } else {
        getData
          .aloneArticle(id)
          .then((res) => {
            // console.log(res.data)
            res.data.content = res.data.content.replace(
              /<img class=""/g,
              '<img class="article-img"',
            );
            res.data.content = res.data.content.replace(
              /墨客云科技 www.mokyun.com/g,
              '<a href="https://www.mokyun.com">墨客云科技</a>',
            );
            res.data.content = res.data.content.replace(
              /墨客云科技www.mokyun.com/g,
              '<a href="https://www.mokyun.com">墨客云科技</a>',
            );
            //						res.data.content = res.data.content.replace(/data-w/g, '""')
            if (res.data.preId == 0) this.leftImg = false;
            else {
              this.leftImg = true;
              res.data.prePic = `${getData.url}${res.data.prePic}`;
            }
            if (res.data.nextId == 0) this.rightImg = false;
            else {
              this.rightImg = true;
              res.data.nextPic = `${getData.url}${res.data.nextPic}`;
            }
            res.data.time = res.data.time.split(' ')[0];
            this.articleData = res.data;
            this.articleData.label = this.articleData.label.split(',');
            if (this.articleData.label[0] == '') this.label = false;
            else this.label = true;
            // console.log(this.articleData);
          })
          .catch((e) => {});
      }
    },

    // 获取右侧热门/推荐
    getHotArticle() {
      getData
        .hotArticle()
        .then((res) => {
          //					console.log(res.data)
          this.recommendArticle = res.data.recommend;
          res.data.recommend.forEach((v, index) => {
            res.data.recommend[index].pic = `${getData.url}${v.pic}`;
          });
          res.data.hot.forEach((v, index) => {
            res.data.hot[index].pic = `${getData.url}${v.pic}`;
          });
          this.hotImage = res.data.hot.slice(0, 2);
          this.hotImage[0].imgUrl = fir;
          this.hotImage[1].imgUrl = sec;
          this.hotArticle = res.data.hot.slice(2);
          //					console.log(this.hot)
        })
        .catch((e) => {});
    },

    // 评论
    submit() {
      let texts = this.review;
      let obj = {};
      let reg = /\S/;
      let that = this;
      if (!reg.test(texts)) {
        this.$message({ message: '评论信息不能为空', type: 'warning' });
      } else {
        obj.lab_id = this.$route.query.id;
        obj.to_id = 0;
        obj.content = texts;
        this.verification().then((res) => {
          if (res) {
            getData.setComment(obj).then((res) => {
              res.data == 'success'
                ? this.getComment(this.count)
                : this.$message.error('评论失败');
              this.review = '';
            });
          } else this.$message.error('验证码错误');
        });
      }
    },

    // 获取评论
    getComment(count) {
      getData
        .getComment(this.$route.query.id)
        .then((res) => {
          //					console.log(res.data)
          // let that = this
          this.commentNum = res.data.length;
          if (count) {
            for (let i = 0; i < 5; i++) {
              this.comments.push(res.data[i]);
            }
          } else {
            //						this.comments = res.data
          }
          this.comments = res.data;
          if (res.data.length == 0) {
            this.commentContent = '你是第一个来评论的,快来试试';
            this.judge = true;
            return;
          } else {
            this.judge = false;
            this.commentContent = '已发布的评论';
            //						console.log(this.comments)
            this.comments.forEach((val, index) => {
              this.getHeadPortrait().then((res) => {
                this.comments[index].headimgurl = res;
              });
              this.comments[index].shows = false;
              if (val.address == '') {
                this.comments[index].name = '匿名';
              } else {
                this.comments[index].name = val.address;
              }
              if (val.reply.length > 0) {
                val.reply.forEach((list, j) => {
                  if (list.address == '') {
                    this.comments[index].reply[j].name = '匿名';
                  } else {
                    this.comments[index].reply[j].name = list.address;
                  }
                });
              }
            });
          }
          this.comments = JSON.parse(JSON.stringify(this.comments));
          //					console.log(this.comments)
        })
        .catch((e) => {});
    },
    // 获取头像
    getHeadPortrait() {
      return new Promise((resolve, reject) => {
        getData
          .getHeadPortrait(this.$route.query.id)
          .then((res) => {
            res.data.forEach((val, index) => {
              val.headimgurl = `${getData.url}${val.headimgurl}`;
            });
            let random = Math.floor(Math.random() * (res.data.length + 1));
            resolve(res.data[random].headimgurl);
          })
          .catch((e) => {
            reject();
          });
      });
    },
    // 回复评论
    reply(id) {
      this.comments.forEach((val, index) => {
        if (val.id == id) {
          this.replyText = '';
          if (val.shows) {
            this.comments[index].shows = false;
          } else {
            this.comments.forEach((z, index) => {
              this.comments[index].shows = false;
            });
            this.comments[index].shows = true;
          }
        }
      });
    },
    // 取消
    cancel() {
      this.comments.forEach((val, index) => {
        this.comments[index].shows = false;
      });
    },
    // 确认提交回复
    sureReply(id) {
      let obj = {};
      let reg = /\S/;
      if (reg.test(this.replyText)) {
        obj.lab_id = this.$route.query.id;
        obj.to_id = id;
        obj.content = this.replyText;

        this.verification().then((res) => {
          if (res) {
            getData
              .setComment(obj)
              .then((res) => {
                res.data == 'success'
                  ? this.getComment(this.count)
                  : this.$message.error('回复失败');
              })
              .catch((e) => {});
          } else this.$message.error('验证码错误');
        });
      } else this.$message({ message: '回复信息不能为空', type: 'warning' });
    },

    // 验证码
    verification() {
      return new Promise((resolve, reject) => {
        let num = '';
        for (var i = 0; i < 4; i++) {
          num += Math.floor(Math.random() * 10);
        }
        let getStatus = localStorage.getItem('code');
        if (getStatus) {
          // resolve(getStatus);
        } else {
          this.$prompt(num, '请输入验证码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
            .then(({ value }) => {
              let code;
              if (value == num) {
                code = true;
                localStorage.setItem('code', code);
              } else code = false;
              // resolve(code);
            })
            .catch(() => {});
        }
      });
    },
    // 查看更多评论
    seeMore() {
      this.count = false;
      this.getComment(this.count);
    },
    // 上下篇跳转
    changeText(id) {
      document.documentElement.scrollTop = 0;
      if (id == 0) return;
      else {
        // 页面跳转
        this.$router.push({
          path: '/laboratorys',
          query: { id },
        });
        // 数据请求
        this.getArticle(id);
        // 获取评论
        this.getComment(this.count);
      }
    },
    // 回到顶部
    goTop() {
      this.showHide = false;
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
*,
a {
  margin: 0;
  padding: 0;
  text-decoration: none;
}
#laboratorys {
  background: #f0f0f0;
}
.row .col-md-12 img {
  width: 100%;
}

.banner {
  width: 100%;
  margin-bottom: 40px;
  position: relative;
}

.banner img {
  width: 100%;
  height: 100%;
}

.banner .texts {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.banner .texts > div {
  width: 100%;
  text-align: center;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.banner .texts > div:nth-child(1) {
  height: 55%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  font-size: 50px;
  font-family: '黑体';
  font-weight: 600;
}
.banner .texts > div:nth-child(2) {
  height: 40%;
  font-size: 15px;
  font-family: '黑体';
}

@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .banner .texts > div:nth-child(1) {
    font-size: 3rem;
  }
  .banner .texts > div:nth-child(2) {
    font-size: 13px;
  }
}
@media only screen and (min-width: 760px) and (max-width: 1100px) {
  .banner .texts > div:nth-child(1) {
    font-size: 2rem;
  }
  .banner .texts > div:nth-child(2) {
    font-size: 12px;
  }
}
@media only screen and (min-width: 540px) and (max-width: 760px) {
  .banner .texts > div:nth-child(1) {
    font-size: 1.2rem;
  }
  .banner .texts > div:nth-child(2) {
    font-size: 0.8rem;
  }
}
@media only screen and (max-width: 540px) {
  .banner .texts > div:nth-child(1) {
    font-size: 1rem;
  }
  .banner .texts > div:nth-child(2) {
    font-size: 0.5rem;
  }
}

.boding {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
}
.boding .recommend {
  /*width: 25%;*/
  width: 400px;
  margin-left: 11px;
}
.boding .recommend .nominate {
  width: 400px;
  padding-top: 25px;
  padding-bottom: 42px;
  padding-left: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 5px 5px 25px #ddd;
}
.boding .recommend .nominate .show-title,
.boding .recommend .hot .show-title {
  width: 90%;
  height: 20px;
  line-height: 20px;
  position: relative;
  margin-bottom: 18px;
}
.boding .recommend .hot .show-title {
  margin-left: 40px;
}
.boding .recommend .nominate .show-title span:first-child,
.boding .recommend .hot .show-title span:first-child {
  display: inline-block;
  width: 4px;
  height: 20px;
  background: #779aff;
  border-radius: 2px;
  margin-left: -15px;
  margin-right: 5px;
}
.boding .recommend .nominate .show-title span:nth-child(2),
.boding .recommend .hot .show-title span:nth-child(2) {
  display: inline-block;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  font-family: Microsoft YaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #353535;
}
.boding .recommend .nominate ul li {
  margin-bottom: 11px;
  padding-right: 15px;
  font-family: Microsoft YaHei;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 0px;
  color: #353535;
  cursor: pointer;
}
.boding .recommend .nominate ul li:hover {
  color: #007aff;
}
.boding .hot {
  width: 100%;
  padding-top: 26px;
  padding-bottom: 60px;
  background: #fff;
  margin-top: 19px;
  border-radius: 10px;
  box-shadow: 5px 5px 25px #ddd;
}
.boding .hot .show-hot-text {
  width: 90%;
  margin: 0 auto;
}
.boding .hot .show-hot-text .show-image {
  width: 100%;
  height: 192px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
.boding .hot .show-hot-text .show-image .bgImg {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.boding .hot .show-hot-text .show-image .topImg {
  width: 64px;
  height: 33px;
  position: absolute;
  top: 0;
  left: 16px;
}
.boding .hot .show-hot-text .show-image:nth-child(2) {
  margin-top: 20px;
}

.show-hot-text .show-other {
  width: 100%;
  margin-top: 23px;
  padding-right: 1px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  box-shadow: 3px 3px 20px #eee;
  border-radius: 8px;
}
.show-hot-text .show-other .ranking {
  width: 30%;
  height: 80px;
  border-radius: 8px 0px 0px 8px;
  overflow: hidden;
  margin-right: 5%;
  position: relative;
}
.show-hot-text .show-other .ranking img {
  width: 100%;
  height: 100%;
}
.show-hot-text .show-other .ranking > div {
  width: 29px;
  height: 19px;
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  color: #fff;
  opacity: 0.5;
  text-align: center;
  line-height: 19px;
}
.show-hot-text .show-other > div:nth-child(2) {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2px 0;
}

.show-other > div:nth-child(2) p:nth-child(1) {
  font-family: Microsoft YaHei;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #353535;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.show-other > div:nth-child(2) p:nth-child(2) {
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #a1a4a5;
}
.boding .center {
  /*width: 45%;*/
  width: 860px;
  /*margin: 0 auto;*/
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 30px;
  border-radius: 10px;
  box-shadow: 5px 5px 5px #ddd;
}
.center .middle {
  width: 92%;
  margin: 0 auto;
}
.center .title {
  font-family: Microsoft YaHei;
  font-size: 25px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #353535;
  text-align: center;
  margin: 40px 0 20px;
}
.center .info {
  /*width: 60%;*/
  margin: 0 auto;
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #779aff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.center .info span {
  margin-left: 10px;
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #a1a4a5;
  /*cursor:pointer;*/
}
.center .info img {
  margin: 0 6px 3px;
}
.center .labels {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.center .labels span {
  padding: 3px 10px;
  color: #fff;
  background: #779aff;
  font-size: 14px;
  border-radius: 3px;
  margin-left: 5px;
  margin-right: 5px;
}
.center .article {
  width: 100%;
  height: auto;
  margin: 50px auto;
  overflow: hidden;
}
.center .article .text {
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #353535;
}
.center .article p img {
  display: inline-block;
  width: 100% !important;
  height: auto;
  margin: 30px 0;
  cursor: pointer;
}
.article hr {
  display: inline-block;
  width: 100%;
  border: 1px solid #cfb5b5;
  opacity: 0.5;
}
.article p .article-img {
  width: 100% !important;
}

.center .pageTurning {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.center .pageTurning > div {
  width: 49%;
  height: 100%;
  background-color: #fef8f8;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  padding: 25px 0;
}
.center .pageTurning .left .page-change,
.center .pageTurning .left .yes-img,
.center .pageTurning .right .page-change,
.center .pageTurning .right .yes-img {
  width: 90%;
  height: 210px;
  margin: 0 auto;
}
.center .pageTurning .left .no-data-page,
.center .pageTurning .right .no-data-page {
  width: 90%;
  margin: 0 auto;
}
@media screen and (min-width: 1100px) and (max-width: 1220px) {
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 175px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1100px) {
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 145px;
  }
}

@media screen and (min-width: 768px) and (max-width: 880px) {
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 175px;
  }
}

@media screen and (min-width: 660px) and (max-width: 768px) {
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 160px;
  }
}
@media screen and (min-width: 530px) and (max-width: 660px) {
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 145px;
  }
}

.center .pageTurning .left > div:nth-child(2),
.center .pageTurning .right > div:nth-child(2) {
  margin-top: 37px;
}
.center .pageTurning > div img {
  width: 100%;
}
.center .pageTurning > div .pic {
  width: 100%;
  height: 100%;
  /* max-height: 230px; */
}

.center .pageTurning .page-change {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 41px;
}
.center .pageTurning .page-change .jump-btn {
  display: inline-block;
  width: 28%;
  padding: 0 15px;
  height: 40px;
  background-color: #fff;
  border-radius: 10px;
  border: solid 1px #d8d5d5;
  color: #000000;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  line-height: 40px;
  overflow: hidden;
}
.center .pageTurning .page-change .jump-btn img {
  width: 18px;
  height: 13px;
}
.center .pageTurning .page-change .jump-txt {
  width: 67%;
  height: 100px;
}
.center .pageTurning .page-change .jump-txt p:nth-child(1) {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #353535;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.center .pageTurning .page-change .jump-txt p:nth-child(2) {
  display: inline-block;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #a1a4a5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.center .comment {
  width: 100%;
  height: auto;
  margin: 45px 0 50px;
}
.center .comment .publish {
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #353535;
}
.center .comment .publish span {
  display: inline-block;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #a1a4a5;
  margin: 0 0 0 10px;
}
.center .comment hr {
  margin: 40px 0 55px;
}

.comment-module {
  width: 100%;
}
.comment-text {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  z-index: 100;
}
.comment-text > div:nth-child(1) {
  width: 9%;
  /* display: flex;
		flex-direction: row;
		align-items: center; */
}

.comment-text > div:nth-child(1) img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}

.comment-text > div:nth-child(2) {
  width: 90%;
  background: #fef8f8;
  padding-left: 17px;
  border-radius: 10px;
  padding-bottom: 10px;
}
@media screen and (min-width: 1100px) and (max-width: 1220px) {
  .comment-text > div:nth-child(1) img {
    width: 60px;
    height: 60px;
  }
  .comment-text > div:nth-child(1) {
    width: 10%;
  }
  .comment-text > div:nth-child(2) {
    width: 89%;
  }
}
@media screen and (min-width: 992px) and (max-width: 1100px) {
  .comment-text > div:nth-child(1) img {
    width: 55px;
    height: 55px;
  }
  .comment-text > div:nth-child(1) {
    width: 11%;
  }
  .comment-text > div:nth-child(2) {
    width: 88%;
  }
}
@media screen and (min-width: 690px) and (max-width: 810px) {
  .comment-text > div:nth-child(1) img {
    width: 55px;
    height: 55px;
  }
}
@media screen and (min-width: 580px) and (max-width: 690px) {
  .comment-text > div:nth-child(1) img {
    width: 50px;
    height: 50px;
  }
  .comment-text > div:nth-child(1) {
    width: 10%;
  }
  .comment-text > div:nth-child(2) {
    width: 89%;
  }
}
@media screen and (min-width: 530px) and (max-width: 580px) {
  .comment-text > div:nth-child(1) img {
    width: 45px;
    height: 45px;
  }
  .comment-text > div:nth-child(1) {
    width: 10%;
  }
  .comment-text > div:nth-child(2) {
    width: 89%;
  }
}
@media screen and (min-width: 420px) and (max-width: 530px) {
  .comment-text > div:nth-child(1) img {
    width: 45px;
    height: 45px;
  }
  .comment-text > div:nth-child(1) {
    width: 13%;
  }
  .comment-text > div:nth-child(2) {
    width: 87%;
  }
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 260px;
  }
}
@media screen and (max-width: 365px) {
  .center .pageTurning .left .yes-img,
  .center .pageTurning .right .yes-img {
    height: 180px;
  }
}

.comment-text > div:nth-child(2) > div:nth-child(1) {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Microsoft YaHei;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #353535;
  margin: 20px 0 10px;
}
@media screen and (max-width: 420px) {
  .comment-text > div:nth-child(1) img {
    width: 40px;
    height: 40px;
  }
  .comment-text > div:nth-child(1) {
    width: 15%;
    margin-right: 1%;
  }
  .comment-text > div:nth-child(2) {
    width: 84%;
  }
  .comment-text > div:nth-child(2) > div:first-child {
    margin: 20px 0 0;
  }
}
.comment-text > div:nth-child(2) > div:nth-child(2) {
  width: 100%;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #504f4f;
  padding-right: 40px;
  line-height: 25px;
}
.comment-module .comment-area {
  width: 90%;
  margin: 0 auto;
  animation: shows 1s forwards;
}
@keyframes shows {
  from {
    height: 0;
    opacity: 0;
  }
  to {
    height: 220px;
    opacity: 1;
  }
}
.comment-module .comment-area textarea,
.comment-module .hide-area textarea {
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 150px;
  max-height: 150px;
  padding-left: 15px;
  padding-top: 10px;
  margin-bottom: 15px;
  background: #fff;
  box-shadow: 3px 5px 5px #f2f2f2;
  border: 1px solid #eee;
  outline: none;
}
.comment-module .comment-area div,
.comment-module .hide-area div {
  text-align: right;
  margin-bottom: 15px;
}
.comment-module .comment-area .el-button,
.comment-module .hide-area .el-button {
  padding: 10px 20px;
  z-index: 1;
}
.comment-module .hide-area {
  display: none;
  width: 90%;
  margin-left: 10%;
  animation: hides 1s forwards;
}
@keyframes hides {
  from {
    height: 220px;
    opacity: 1;
  }
  to {
    height: 0;
    opacity: 0;
    display: none;
  }
}
.comment-module .reply {
  width: 100%;
}
.comment-module .reply > div {
  width: 100%;
  padding: 15px 0;
  text-align: right;
  z-index: 999;
}
.comment-module .reply > div span {
  margin-left: 12px;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 0px;
  color: #a1a4a5;
  cursor: pointer;
}
.comment-module .reply > div img {
  cursor: pointer;
  width: 7%;
}
@media screen and (min-width: 1340px) {
  .comment-module .reply > div img {
    width: 3%;
  }
}
@media screen and (min-width: 992px) and (max-width: 1340px) {
  .comment-module .reply > div img {
    width: 4%;
  }
}
@media screen and (min-width: 650px) and (max-width: 992px) {
  .comment-module .reply > div img {
    width: 4%;
  }
}
@media screen and (max-width: 876px) {
  .boding {
    margin: 0;
  }
  .center {
    border-radius: 0 !important;
  }
}
.comment-module .reply-text {
  width: 100%;
  padding-bottom: 20px;
  background: #fff;
  z-index: 100;
}
.comment-module .reply-text > div {
  width: 88%;
  margin-left: 12%;
}
.comment-module .reply-text > div span:nth-child(1) {
  font-size: 14px;
  color: #a1a4a5;
}
.comment-module .reply-text > div span:nth-child(2) {
  font-size: 16px;
  color: #666;
  margin-left: 5px;
  letter-spacing: 1px;
}
.seeMore {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  border: 1px solid #f2f2f2;
  color: #aaa;
  margin-top: 10px;
}

.login {
  font-family: Microsoft YaHei;
  font-size: 26px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #353535;
  width: 100%;
  height: 321px;
  border: solid 1px #a8abac;
  text-align: center;
  line-height: 321px;
}
.login a {
  font-family: Microsoft YaHei;
  font-size: 26px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #779aff;
}
.textarea {
  width: 100%;
  height: 321px;
  background-color: #fef8f8;
  border: solid 1px #eee;
  padding: 46px 6% 127px;
  margin: 46px 0;
}
.textarea textarea {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 145px;
  min-width: 100%;
  min-height: 145px;
  background: white;
  font-family: Microsoft YaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #a1a4a5;
  padding: 10px 30px;
  outline: none;
  border: 1px solid #eee;
  box-shadow: 5px 5px 5px #f2f2f2;
  border-radius: 10px;
}
.textarea form {
  width: 100%;
  height: 100%;
  background: white;
}
.textarea button {
  float: right;
  position: relative;
  width: 113px;
  height: 40px;
  background-color: #779aff;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  border: none;
  margin-top: 30px;
}

.goTop {
  width: 50px;
  height: 50px;
  text-align: center;
  position: fixed;
  bottom: 50px;
  right: 50px;
  background: #0da4d3;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s;
}
.goTop:hover {
  transform: scale(1.05);
  transition: all 0.5s;
}
.goTop > div {
  width: 100%;
  height: 50%;
}
.goTop > div:first-child {
  height: 30%;
  margin-top: 3px;
}
@media screen and (max-width: 1080px) {
  .center {
    width: 100%;
  }
}

@media only screen and (max-width: 768px) and (min-width: 580px) {
  .center .title {
    font-size: 22px;
  }
  .center .info,
  .center .info span {
    font-size: 15px;
  }
  .center .labels span {
    font-size: 13px;
  }
}
@media only screen and (max-width: 580px) {
  .center .title {
    font-size: 16px;
  }
  .center .info,
  .center .info span {
    font-size: 14px;
  }
  .center .labels span {
    font-size: 12px;
  }
}

@media only screen and (max-width: 530px) {
  .center .pageTurning {
    flex-direction: column;
  }
  .center .pageTurning > div {
    width: 100%;
    margin-bottom: 15px;
  }
  .center .comment {
    margin: 30px 0 50px;
  }
  .center .article {
    margin: 25px auto;
  }
  .center .pageTurning .page-change .jump-btn {
    padding: 0 10px;
    font-size: 12px;
  }
  .center .pageTurning .page-change .jump-btn img {
    width: 13px;
    height: 10px;
  }
  .center .title {
    margin: 20px 0 20px;
  }
  .banner {
    margin-bottom: 0;
  }
  .textarea textarea {
    max-height: 105px;
    min-height: 105px;
  }
}

@media only screen and (min-width: 768px) {
  .banner {
    margin-top: 51px;
  }
}
@media only screen and (max-width: 768px) {
  .banner {
    margin-top: 53px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/action.vue